module.exports = __webpack_public_path__ + "img/amex.f935b059.svg";